import { useEffect, useState } from 'react';
import { Card } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { cpdAPI, errMsg } from '../../lib/cpdRegisterAPI';
import { toast } from 'sonner';
import { humanizeEnums } from './CPDStatus';

export const CPDAuditTab = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { cpdAPI.audit().then((r) => setRows(r.items)).catch((e) => toast.error(errMsg(e))); }, []);
  return (
    <Card className="overflow-x-auto" data-testid="cpd-audit-tab"><Table>
      <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Action</TableHead><TableHead>Record</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
      <TableBody>{rows.map((r) => (
        <TableRow key={r.id}><TableCell className="text-xs whitespace-nowrap">{new Date(r.created_at).toLocaleString('en-AU')}</TableCell>
          <TableCell className="text-xs font-mono">{r.action}</TableCell><TableCell className="text-xs">{r.target_type}</TableCell>
          <TableCell className="text-xs max-w-md truncate" title={humanizeEnums(JSON.stringify(r.meta))}>{humanizeEnums(JSON.stringify(r.meta))}</TableCell></TableRow>))}
      </TableBody></Table></Card>
  );
};
